import {calculateRouteModel as routingModel} from './calculateRoute';

export function batchCalculateRouteModel(data) {
    if (!Array.isArray(data.batchItems)) {
        return null;
    }

    data.batchItems = data.batchItems.map((batchItem) => {
        if (batchItem.response.error) {
            return { error: batchItem.response.error };
        } else {
            return routingModel(batchItem.response);
        }
    });

    return data;
}
